module["exports"] = [
  "###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/building_number.js
// module id = 1167
// module chunks = 0